exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3k_0NQjo7LdE63{margin-top:8px;margin-bottom:0}", ""]);

// exports
exports.locals = {
	"selectTeamSubmitButton": "_3k_0NQjo7LdE63"
};